import RequestForm from "../components/sections/request/RequestForm";


export default function RequestPage() {
  return (
    <main className="request-page">
      <div className="request-container">
        <RequestForm />
      </div>
    </main>
  );
}

